var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('verification-prompt',{attrs:{"is-verified":_vm.isVerified}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }